export type Url = string & { readonly _: unique symbol };

export enum DataProcessingScope {
    Registration = 'registration',
    SkinAnalyses = 'skin-analyses',
}

export enum ApiErrorCodes {
    INVALID_VATIN = '1596620056994',
    INVALID_COUNTRY_POSTCODE = '1674032298',
}

export enum ApiErrorStatus {
    BAD_REQUEST = '400',
    FORBIDDEN = '403',
    NOT_FOUND = '404',
    GONE = '410',
    INTERNAL_SERVER_ERROR = '500',
}

export interface ApiError {
    code: ApiErrorCodes;
    id: string;
    status: ApiErrorStatus;
    title: string;
}

export interface BirthDay {
    day: string;
    month: string;
    year: string;
}

export enum ApiCallState {
    InProgress,
    Successful,
    Failure,
}
